import { render, staticRenderFns } from "./ConveniosVencidos.vue?vue&type=template&id=598b1aff&scoped=true"
import script from "./ConveniosVencidos.vue?vue&type=script&lang=js"
export * from "./ConveniosVencidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598b1aff",
  null
  
)

export default component.exports